import React, { useMemo } from 'react'
import { useQuery } from 'react-apollo';
import NoticationContext from './NotificationContext';
import { GET_NOTIFICATION_WITHOUT_PAGINATION } from '../ui/pages/AssociateVendors/query';

function NotificationState(props) {
    const { data, loading, refetch } = useQuery(GET_NOTIFICATION_WITHOUT_PAGINATION, {
        variables: {},
        fetchPolicy: "cache-and-network",
    })
    const allNotification = useMemo(() => data?.getAllNotificationsWithoutPagination || [], [data])

    return (
        <NoticationContext.Provider value={{ allNotification, loading, refetch }}>
            {props.children}
        </NoticationContext.Provider>
    )
}

export default NotificationState